import { storage } from '../../utils/storage';
import { SET_DEVICE } from './actions';
import { DEVICEKEY } from './state';

export const reducers = {
    [SET_DEVICE](state: any, newS: any): void {
        const newDeviceValue = newS.payload;

        storage.set(DEVICEKEY, newDeviceValue);
        state.device = newDeviceValue;
    }
}